import { cn } from "@app/lib/utils";
import { trans } from "@mongez/localization";

/**
 * Subsidiary drawer table header component
 * Displays column headers for subsidiary data table
 */
export function SubsidiaryDrawerHeader() {
  return (
    <div
      className={cn(
        "mb-4 hidden items-center rounded-full bg-bright-orange sm:mb-5 md:flex",
        "px-4 py-2 sm:px-8 sm:py-3 md:px-12 lg:px-16",
      )}
    >
      <div
        className={cn(
          "grid w-full grid-cols-6 gap-2 sm:gap-4 items-center",
          "text-xs font-semibold text-white sm:text-sm",
        )}
      >
        <div>
          {trans("aboutUsPage.leadership.subsidiaries.table.nameColumn")}
        </div>
        <div>
          {trans("aboutUsPage.leadership.subsidiaries.table.capitalColumn")}
        </div>
        <div>
          {trans("aboutUsPage.leadership.subsidiaries.table.ownershipColumn")}
        </div>
        <div>
          {trans("aboutUsPage.leadership.subsidiaries.table.activityColumn")}
        </div>
        <div>
          {trans(
            "aboutUsPage.leadership.subsidiaries.table.countryOfOperation",
          )}
        </div>
        <div>
          {trans(
            "aboutUsPage.leadership.subsidiaries.table.countryOfIncorporation",
          )}
        </div>
      </div>
      <span className={cn("ms-2 size-4 sm:ms-4 sm:size-5")} />
    </div>
  );
}
